import { createRefetchContainer, graphql } from 'react-relay';
import WorkspacesComponent from './WorkspacesComponent';

export default createRefetchContainer(WorkspacesComponent,
  {
    viewer: graphql`
      fragment WorkspacesContainer_viewer on User {
        id
        ...AvailabilityCalendarContainer_viewer
      }
    `,
    node: graphql`
      fragment WorkspacesContainer_node on Event {
        id
        title
        start_at
        end_at
        time_zone
        can_edit
        user_contacts(first: 99999) {
          edges {
            node {
              first_name
              last_name
              user_contact_emails(first: 99999) {
                edges {
                  node {
                    address
                  }
                }
              }
            }
          }
        }
        user_event {
          start_at
          end_at
          time_zone
        }
        workspaces(first: 99999) @connection(key: "WorkspacesContainer_workspaces") {
          edges {
            node {
              id
              title
              share_token
              permissions
              can_email
              estimates(first: 99999) @connection(key: "EventShowContainer_estimates")  {
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              invoices(first: 99999) @connection(key: "EventShowContainer_invoices")  {
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              forms(first: 99999) @connection(key: "WorkspacesContainer_forms")  {
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              music_planners(first: 99999) @connection(key: "WorkspacesContainer_music_planners")  {
                edges {
                  node {
                    id
                    title
                    can_edit
                  }
                }
              }
              contracts(first: 99999) @connection(key: "EventShowContainer_contracts")  {
                edges {
                  node {
                    id
                    title
                    editable
                    contract_signature_blocks {
                      edges {
                        node {
                          signed_at
                        }
                      }
                    }
                  }
                }
              }
              wuploads(first: 99999) @connection(key: "WorkspacesContainer_wuploads") {
                edges {
                  node {
                    id
                    mimetype
                    name
                    url
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
    query WorkspacesContainer_RefetchQuery($id: ID!) {
      node(id: $id) {
        ...WorkspacesContainer_node
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/Workspace/WorkspacesContainer.js